import styled, { css } from 'styled-components'

import { mobileCSS } from '@measures/responsive'
import { intent as intentConst } from '@utils/chatbot/types'

import { AnswerType, SourceType } from '../types'
import AnswerParagraph from './AnswerParagraph'
import ExpandableContent from './ExpandableContent'

import type { FunctionComponent } from 'react'

type AnswerContentProps = {
  answer: AnswerType
  onExpandClick: () => void
  onSourceLinkClick: (linkItem: SourceType) => void
  onSourcesClick: () => void
}

const StyledContent = styled.div`
  ${({
    theme: {
      spacing: { spacing24, spacing16 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing24};

    ${mobileCSS(css`
      gap: ${spacing16};
    `)}
  `}
`

const AnswerContent: FunctionComponent<AnswerContentProps> = ({
  answer,
  onExpandClick,
  onSourceLinkClick,
  onSourcesClick,
}) => {
  const hasSources = answer?.links && Object.keys(answer?.links).length > 0
  const isExpandable = !(
    answer.questionData?.isSuggestedQuestion ||
    answer.intent === intentConst.GUARDRAIL ||
    answer.intent === intentConst.GREETING
  )

  return (
    <ExpandableContent
      answer={answer}
      isExpandable={isExpandable}
      hasSources={hasSources}
      onSourcesClick={onSourcesClick}
      onExpandClick={onExpandClick}
    >
      <StyledContent>
        {answer.content?.map((contentItem, index) => {
          const linkItem = answer.links?.[contentItem?.link ?? '']
          const contentImage = linkItem?.image

          return (
            <AnswerParagraph
              key={`answer-paragraph-${index}`}
              linkItem={linkItem}
              contentItem={contentItem}
              contentImage={contentImage}
              category={contentItem.category}
              onSourceLinkClick={onSourceLinkClick}
            />
          )
        })}
      </StyledContent>
    </ExpandableContent>
  )
}

export default AnswerContent
